import React, { useEffect, useState } from 'react';
import LoadingImage from '../../../assets/media/loader.gif';
import Nav from '../nav';
import Header from '../../../common/header/header';
import {
  baseUrl,
  modal_chart_icon,
  modal_excel_icon,
} from '../../../api/baseUrl';
import {
  SegmentedControl,
  Loader as MantineLoader,
  MultiSelect,
  Button,
  Select,
} from '@mantine/core';
import { DatePickerInput, YearPickerInput } from '@mantine/dates';

import { IconChevronDown, IconCalendar } from '@tabler/icons-react';
import { useCookies } from 'react-cookie';
import {
  generateDateRanges,
  valueCheckGlobalForFinancials,
  valueCheckGlobalNew,
} from '../../../GlobalFunctions';
import ComparisonChartModal from '../../../layout/modals/ComparisonChartModal';
// import DailyPrice from "../../../components/economy/daily-price/index";
import axios from 'axios';
import * as XLSX from 'xlsx';
import Dailyprice from './dailyprice';
import { useRef } from 'react';

const Cement = () => {
  const [company, setCompany] = useState('All Companies');
  const [yearpickervalue, setYearPickerValue] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [indices, setIndices] = useState('dispatches');
  const [type, setType] = useState('domestic');
  const [frequency, setFrequency] = useState('monthly');
  const [parameter, setParameter] = useState('value');
  const [weeklyvalue, setWeeklyValue] = useState(true);
  const [growth, setGrowth] = useState('MoM');

  const [cookies, setCookies, removeCookies] = useCookies();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [startDateOptions, setStartDateOptions] = useState([]);
  const [endDateOptions, setEndDateOptions] = useState([]);

  const [dates, setDates] = useState([]);
  const [filings, setFilings] = useState([]);
  const [priceDates, setPriceDates] = useState([]);

  const [filter, setFilter] = useState([]);
  const [brand, setBrand] = useState([]);
  const [data, setData] = useState([]);

  const [chartActive, setChartActive] = useState(false);
  const scrollRef = useRef(null);
  const [label, setLabel] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [chartData, setchartData] = useState([]);
  const [records, setRecords] = useState([]);

  const [timePeriod, setTimePeriod] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [filename, setFilename] = useState('');
  const [typeValue, setTypeValue] = useState('');
  const [dateValue, setDateValue] = useState([null, null]);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  // For daily price table
  // const [currentPosts, setCurrentPosts] = useState([]);

  const icon = <IconChevronDown size={16} />;

  const [error, setError] = useState({
    startDateValue: '',
    endDateValue: '',
    dateRange: '',
    brandSelection: '',
  });

  const [form, setForm] = useState({
    startDateValue: '',
    endDateValue: '',
  });

  const handleChange = (name, value) => {
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleIndices = (value) => {
    if (
      value === 'prices' ||
      value === 'utilization' ||
      value === 'marketshare'
    ) {
      setParameter('value');
    }
    if (value === 'prices') {
      setWeeklyValue(false);
      setFrequency('weekly');
      setGrowth('WoW');
      setType('All');
    } else {
      setWeeklyValue(true);
      setFrequency('monthly');
      setGrowth('MoM');
      setType('domestic');
    }
    setIndices(value);
  };

  const validateForm = () => {
    let isValid = true;
    let newErrors = {
      startDateValue: '',
      endDateValue: '',
      dateRange: '',
      brandSelection: '',
    };

    if (indices !== 'dailyprice') {
      if (!form.startDateValue) {
        newErrors.startDateValue = 'Start date is required';
        isValid = false;
      }
      if (!form.endDateValue) {
        newErrors.endDateValue = 'End date is required';
        isValid = false;
      }
    } else {
      if (!dateValue || !dateValue[0] || !dateValue[1]) {
        newErrors.dateRange = 'Date range is required';
        isValid = false;
      }
      if (typeValue.length === 0) {
        newErrors.brandSelection = 'Brand selected is required';
        isValid = false;
      }
    }

    setError(newErrors);
    return isValid;
  };

  function getThirteenMonthsBackRange(inputDate) {
    const startDate = new Date(inputDate); // make a copy for calculation
    const endDate = new Date(inputDate); // input date as start
    startDate.setMonth(endDate.getMonth() - 13); // subtract 13 months

    return {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0],
    };
  }

  const handleChartModal = (company_name, label, chartData) => {
    setCompanyName(company_name);
    setLabel(label);
    setchartData(chartData);
    setChartActive(true);
  };

  const handleSubmit = () => {
    setFilename(
      'Cement - ' +
        indices +
        ' (' +
        type +
        ') - ' +
        parameter +
        ' - ' +
        frequency
    );
    if (validateForm()) {
      setRecords([]);
      if (form.startDateValue > form.endDateValue) {
        setErrorMessage('Start date must be earlier than end date.');
        return false;
      }
      setErrorMessage('');

      if (form.startDateValue != '' && form.endDateValue != '') {
        setIsLoading(false);

        axios
          .post(`${baseUrl}/sector/cement`, {
            company: company,
            sdate: form.startDateValue,
            edate: form.endDateValue,
            indices: indices,
            type: type,
            parameter: parameter,
            frequency: frequency,
            growth: growth,
          })
          .then(function (response) {
            setRecords(response.data);
            setIsLoading(true);
            const scrollContainer = scrollRef.current;
            if (scrollContainer) {
              scrollContainer.scrollLeft = scrollContainer.scrollWidth;
            }
          })
          .catch(function (error) {
            console.log('Error fetching data:', error);
          });
      }
    }
  };

  const handleSearch = (e) => {
    if (!validateForm()) return;
    let url2 = `${baseUrl}/cement?page=1&postsperpage=1000`;

    if (!dateValue || !dateValue[0] || !dateValue[1]) {
      url2 = removeParam('date', url2);
    } else {
      const sd_time = new Date(dateValue[0]).getTime() / 1000;
      const ed_time = new Date(dateValue[1]).getTime() / 1000;
      url2 = removeParam('date', url2);
      url2 += `&date=${[sd_time, ed_time].toString()}`;
    }

    if (typeValue == '') {
      url2 = removeParam('name', url2);
    } else {
      url2 = removeParam('name', url2);
      url2 += `&name=${typeValue}`;
    }

    setIsLoading(false);
    axios
      .get(url2)
      .then((res) => {
        // setCurrentPosts(res.data.data);
        setFilings(res.data.data);
        // setCheck(true);
        setIsLoading(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleExport = () => {
    const table = document.getElementById('cement-table');
    const wb = XLSX.utils.table_to_book(table, { sheet: 'Sheet 1' });
    XLSX.writeFile(wb, filename + '.xlsx');
  };

  function removeParam(key, sourceURL) {
    var rtn = sourceURL.split('?')[0],
      param,
      params_arr = [],
      queryString =
        sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
    if (queryString !== '') {
      params_arr = queryString.split('&');
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split('=')[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
    }
    return rtn;
  }

  const handleTypeValue = (value) => {
    setTypeValue(value);
    setError((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.length > 0) {
        delete newErrors.brandSelection;
      }
      return newErrors;
    });
  };

  const handleDateValue = (value) => {
    setDateValue(value);

    setError((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value && value[0] && value[1]) {
        delete newErrors.dateRange;
      }
      return newErrors;
    });
  };

  const formatMoney = (value) => {
    if (value === null || value === undefined) return '-';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  useEffect(() => {
    fetch(`${baseUrl}/sector/cement`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setFilter(data.company);
        setBrand(data.brand);
        setDates(data.dates);
        setPriceDates(data.pricedates);
        const default_date = getThirteenMonthsBackRange(
          data.dates.monthly[0].start_date
        );
        handleChange('startDateValue', default_date.startDate);
        handleChange('endDateValue', default_date.endDate);
        setIsLoadingData(true);
        const scrollContainer = scrollRef.current;
        if (scrollContainer) {
          scrollContainer.scrollLeft = scrollContainer.scrollWidth;
        }
      });
  }, []);

  useEffect(() => {
    // setForm({
    //   startDateValue: '',
    //   endDateValue: '',
    // });
    var check_array = {
      WoW: 'weekly',
      MoM: 'monthly',
      QoQ: 'quarterly',
      HoH: 'halfyearly',
      YoY: 'CY',
    };

    let check = '';
    let datess = [];

    if (parameter == 'growth') {
      check = growth;
      datess = dates[check_array[growth]] || [];
    } else if (parameter == 'value') {
      check = frequency;
      datess = dates[frequency] || [];
    }

    setStartDateOptions(datess);
    setEndDateOptions(datess);

    if (check === 'weekly' || check === 'WoW') {
      setStartDate('Weekly Start');
      setEndDate('Weekly End');
    } else if (check === 'monthly' || check === 'MoM') {
      setStartDate('Month Start');
      setEndDate('Month End');
    } else if (check === 'quarterly' || check === 'QoQ') {
      setStartDate('Quarterly Start');
      setEndDate('Quarterly End');
    } else if (check === 'halfyearly' || check === 'HoH') {
      setStartDate('HY Start');
      setEndDate('HY End');
    } else if (check === 'CY' || check === 'YoY') {
      setStartDate('CY Start');
      setEndDate('CY End');
    } else if (check === 'FY' || check === 'YoY') {
      setStartDate('FY Start');
      setEndDate('FY End');
    }
  }, [frequency, dates, growth]);

  useEffect(() => {
    if (
      form.startDateValue !== '' &&
      form.endDateValue !== '' &&
      !hasSubmitted
    ) {
      handleSubmit();
      setHasSubmitted(true); // taake dobara na chale
    }
  }, [form.startDateValue, form.endDateValue, hasSubmitted]);

  useEffect(() => {
    const shouldReset =
      parameter === 'growth' ||
      ['quarterly', 'FY', 'halfyearly', 'CY'].includes(frequency);

    if (shouldReset) {
      setForm({
        startDateValue: '',
        endDateValue: '',
      });
    }
  }, [parameter, frequency]);

  return (
    <>
      <Header />
      <div className="inflation-main analyst">
        <div className="row omcboxed sector-flex-line" style={styles.navWidth}>
          <Nav nopadding={true} />
        </div>

        <div className="omc-view container container_box">
          {isLoadingData ? (
            <>
              <div className="inflation-input-multi">
                <Select
                  placeholder="Select Company"
                  searchable
                  data={filter}
                  value={company}
                  onChange={setCompany}
                  disabled={indices === 'dailyprice'}
                  className="cement-select-field"
                  rightSection={icon}
                />
              </div>
              <div className="row m-auto">
                <div className="col-md-12 p-0">
                  <div className="view-type">
                    <span>Step 2: Indices vs Prices</span>
                  </div>
                  <div className="inflation-indices-box">
                    <div className="view-tabs-box radio_data1 radio_tabs12 cement-first-tabs">
                      <SegmentedControl
                        value={indices}
                        onChange={handleIndices}
                        data={[
                          { label: 'Dispatches', value: 'dispatches' },
                          { label: 'Utilization', value: 'utilization' },
                          { label: 'Market Share', value: 'marketshare' },
                          { label: 'Capacity', value: 'capacity' },
                          { label: 'Prices', value: 'prices' },
                          { label: 'Daily Price', value: 'dailyprice' },
                        ]}
                        styles={{
                          control: {
                            '&:first-of-type': {
                              borderLeft:
                                '1px solid rgb(57 109 213 / 50%) !important',
                            },
                          },
                        }}
                      />
                    </div>
                    {(indices === 'dispatches' ||
                      indices === 'utilization' ||
                      indices === 'marketshare' ||
                      indices === 'prices') && (
                      <div className="view-tabs-box radio_data1 radio_tabs12 cement-first-tabs">
                        <SegmentedControl
                          value={type}
                          onChange={setType}
                          className="Entity-dropdown"
                          data={
                            indices === 'prices'
                              ? [
                                  { label: 'All', value: 'All' },
                                  { label: 'North', value: 'North' },
                                  { label: 'South', value: 'South' },
                                ]
                              : [
                                  { label: 'Domestic', value: 'domestic' },
                                  {
                                    label: 'Export',
                                    value: 'export',
                                    disabled:
                                      indices === 'marketshare' ? true : false,
                                  },
                                  {
                                    label: 'Total',
                                    value: 'total',
                                    disabled:
                                      indices === 'marketshare' ? true : false,
                                  },
                                ]
                          }
                          styles={{
                            control: {
                              '&:first-of-type': {
                                borderLeft:
                                  '1px solid rgb(57 109 213 / 50%) !important',
                              },
                            },
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-12 p-0 fertilizer-box-top">
                  <div className="view-type">
                    <span>Step 3: Select Parameter</span>
                  </div>
                  {indices !== 'dailyprice' && (
                    <div className="inflation-indices-box mb-4">
                      <div className="view-tabs-box1 radio_data1 radio_tabs12 select_parameter">
                        <SegmentedControl
                          value={parameter}
                          onChange={setParameter}
                          data={[
                            { label: 'Value', value: 'value' },
                            {
                              label: 'Growth',
                              value: 'growth',
                              disabled: indices == 'dispatches' ? false : true,
                            },
                          ]}
                          styles={{
                            control: {
                              '&:first-of-type': {
                                borderLeft:
                                  '1px solid rgb(57 109 213 / 50%) !important',
                              },
                            },
                          }}
                        />
                        {parameter === 'growth' && (
                          <SegmentedControl
                            value={growth}
                            onChange={setGrowth}
                            data={[
                              {
                                label: 'WoW',
                                value: 'WoW',
                                disabled: weeklyvalue,
                              },
                              { label: 'MoM', value: 'MoM' },
                              { label: 'QoQ', value: 'QoQ' },
                              { label: 'HoH', value: 'HoH' },
                              { label: 'YoY', value: 'YoY' },
                            ]}
                            styles={{
                              control: {
                                '&:first-of-type': {
                                  borderLeft:
                                    '1px solid rgb(57 109 213 / 50%) !important',
                                },
                              },
                            }}
                          />
                        )}
                      </div>
                      {parameter === 'value' && (
                        <div className="view-tabs-box radio_data1 radio_tabs12">
                          <SegmentedControl
                            value={frequency}
                            onChange={setFrequency}
                            data={[
                              {
                                label: 'Weekly',
                                value: 'weekly',
                                disabled: weeklyvalue,
                              },
                              {
                                label: 'Monthly',
                                value: 'monthly',
                                disabled: !weeklyvalue,
                              },
                              {
                                label: 'Quarterly',
                                value: 'quarterly',
                                disabled: !weeklyvalue,
                              },
                              {
                                label: 'Half Yearly',
                                value: 'halfyearly',
                                disabled: !weeklyvalue,
                              },
                              {
                                label: 'CY',
                                value: 'CY',
                                disabled: !weeklyvalue,
                              },
                              {
                                label: 'FY',
                                value: 'FY',
                                disabled: !weeklyvalue,
                              },
                            ]}
                            styles={{
                              control: {
                                '&:first-of-type': {
                                  borderLeft:
                                    '1px solid rgb(57 109 213 / 50%) !important',
                                },
                              },
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="cement-slt-field mt-0 cement-sector-input">
                {/* <div className="search-box-filter mt-4"> */}
                {indices === 'dailyprice' ? (
                  <>
                    <div className="filings-date-field reseach-date-field search-filter-field cement-sector-sizing">
                      <DatePickerInput
                        clearable
                        type="range"
                        value={dateValue}
                        onChange={handleDateValue}
                        valueFormat="DD MMM, YYYY"
                        placeholder="Select Date Range"
                        label="Date"
                        className="news-date-picker"
                        error={error.dateRange}
                        mx="auto"
                        icon={<IconCalendar size="1.1rem" stroke={1.5} />}
                      />
                    </div>

                    <div className="filter-text-field search-filter-field cement-sector-sizing">
                      <Select
                        data={brand}
                        value={typeValue}
                        onChange={handleTypeValue}
                        className="multi-icon-bar"
                        rightSection={icon}
                        placeholder="Select Brand"
                        searchable
                        error={error.brandSelection}
                        label="Brand"
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <Select
                      placeholder={startDate}
                      value={form.startDateValue}
                      label="Start date"
                      onChange={(value) =>
                        handleChange('startDateValue', value)
                      }
                      data={startDateOptions}
                      rightSection={icon}
                      error={error.startDateValue}
                      className="select-dta-field"
                    />
                    <Select
                      placeholder={endDate}
                      value={form.endDateValue}
                      label="End date"
                      onChange={(value) => handleChange('endDateValue', value)}
                      data={endDateOptions}
                      rightSection={icon}
                      error={error.endDateValue}
                      className="select-dta-field"
                    />
                  </>
                )}

                <div className="search-clear-button">
                  <Button
                    className="search-btn-stle"
                    onClick={
                      indices === 'dailyprice' ? handleSearch : handleSubmit
                    }
                  >
                    Search
                  </Button>
                  <Button
                    className="search-btn-stle clear-btn-stl"
                    onClick={() => {
                      setForm({ startDateValue: '', endDateValue: '' });
                      setDateValue([null, null]);
                      setTypeValue([]);
                    }}
                  >
                    Clear
                  </Button>
                  {errorMessage && (
                    <h1
                      style={{
                        color: 'red',
                        marginTop: '10px',
                        fontSize: '14px',
                      }}
                    >
                      {errorMessage}{' '}
                    </h1>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div
              style={{ width: '100%', height: '100%', color: '#426fd7' }}
              className="main-loader d-flex flex-column justify-content-center align-items-center"
            >
              <img src={LoadingImage} style={{ height: '500px' }} />
            </div>
          )}
        </div>
        {isLoading ? (
          <>
            {indices === 'dailyprice' && filings.length ? (
              <Dailyprice filings={filings} />
            ) : indices !== 'dailyprice' ? (
              <div className="omc-view-txt inflation-data container container_box">
                <div className="omc-volume">
                  <div className="omc-excel-volume inflation-excel-right">
                    <div className="omc-excel-down">
                      <span onClick={handleExport}>
                        Download
                        <div
                          dangerouslySetInnerHTML={{ __html: modal_excel_icon }}
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    className="ask-table-format cement-tbl-row"
                    ref={scrollRef}
                  >
                    <table className="table" id="cement-table">
                      <thead>
                        <tr>
                          <th style={styles.stickyColumn}>
                            {filename}
                            &nbsp;
                          </th>
                          {records.length ? (
                            records[0]?.data.map((item, index) => (
                              <th key={index} className="right-align">
                                {item.year}
                              </th>
                            ))
                          ) : (
                            <th className="right-align" colspan="10">
                              &nbsp;
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {records.length ? (
                          records.map((item, index) => (
                            <tr
                              key={index}
                              className={
                                item.label == 'Total' ||
                                item.label == 'South' ||
                                item.label == 'North'
                                  ? 'font-weight-bold'
                                  : ''
                              }
                            >
                              <td
                                className="sticky-column"
                                style={styles.stickyColumn}
                              >
                                {item.value}&nbsp;-&nbsp;{item.plant}
                                <div className="chart-omc-row float-right">
                                  <span
                                    style={styles.chart}
                                    onClick={() => {
                                      handleChartModal(
                                        item.name,
                                        item.label,
                                        item.data
                                      );
                                    }}
                                  >
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: modal_chart_icon,
                                      }}
                                    />
                                  </span>
                                </div>
                              </td>
                              {item.data.map((item2, index2) => (
                                <td key={index2} className="right-align">
                                  {valueCheckGlobalNew(item2.value)}
                                </td>
                              ))}
                            </tr>
                          ))
                        ) : (
                          <td className="left-align" colspan="10">
                            {'Record Not Found'}
                          </td>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
            {/* <DailyPrice/> */}
            {chartActive && (
              <ComparisonChartModal
                chartActive={chartActive}
                setChartActive={setChartActive}
                companyname={companyName}
                label={label}
                chartData={chartData}
                slice={false}
              />
            )}
          </>
        ) : (
          <div
            style={{ width: '100%', height: '100%', color: '#426fd7' }}
            className="main-loader d-flex flex-column justify-content-center align-items-center"
          >
            <img src={LoadingImage} style={{ height: '500px' }} />
          </div>
        )}
      </div>
    </>
  );
};

const styles = {
  navWidth: {
    width: '100%',
    fontSize: '14px',
    margin: 'auto',
    marginBottom: '10px',
    justifyContent: 'space-between',
  },
  stickyColumn: {
    position: 'sticky',
    left: '0px',
    // display: "flex",
    zIndex: '4',
  },
  rowsWidth: {
    width: '160px',
    float: 'left',
  },
};

export default Cement;
